/*
Copyright (c) 2012-2022 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** the format should be #RRGGBBAA
 * Color names are found in `https://www.htmlcsscolor.com`
 * If there is not a suitable color name, please use `c${RRGGBBAA}` format
 * Can use any 3rd-plugin plugin(like `Color Hight` in vs-code) to highlight the hex string
 */

export enum Color {
  aeroBlue = "#CBEFDBFF",
  aliceBlue = "#EAEFF2FF",
  black = "#1C1C1CFF",
  bondiBlue = "#0B8CAFFF",
  bubbles90 = "#E6F7EDE6",
  festival = "#F7C942FF",
  flamingo = "#E95E41FF",
  floralWhite90 = "#FEF9EBE6",
  goldTip = "#E6AC23FF",
  irisBlue = "#07ACD0FF",
  linkWater = "#CCD6DDFF",
  manatee = "#898d97FF",
  mineralGreen = "#505563FF",
  nightRider = "#2F2F2FFF",
  nero = "#222222FF",
  offYellow80 = "#FDF4D8CC",
  pacificBlue = "#00A5CFFF",
  pacificBlue95 = "#00A5CFF2",
  remy = "#FCDFDBFF",
  salmon = "#FF7C6BFF",
  shamrock = "#00B14FFF",
  transparent = "#FFFFFF00",
  vulcan = "#363A45FF",
  white = "#FFFFFFFF",
  whiteSmoke = "#FDEFEEFF",
  c13C2C2 = "#13C2C2FF",
  c87E8DE = "#87E8DEFF",
  cE6FFFB = "#E6FFFBFF",
  cF7F9FB = "#F7F9FBFF",
  c818799 = "#818799FF",
  c363A45 = "#363A45FF",
  cCBD6DD = "#CBD6DDFF",
  c1C1C1C80 = "#1C1C1C80",
  cF7F9FB80 = "#F7F9fB80",
  cEE6352 = "#EE6352FF",
}
